import { render } from "./ContributorSectionFiscalIdentification.vue?vue&type=template&id=2d4a6048&scoped=true"
import script from "./ContributorSectionFiscalIdentification.vue?vue&type=script&lang=js"
export * from "./ContributorSectionFiscalIdentification.vue?vue&type=script&lang=js"

import "./ContributorSectionFiscalIdentification.vue?vue&type=style&index=0&id=2d4a6048&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4a6048"]])

export default __exports__